import React from 'react';
import { useTheme } from 'styled-components';

export const MoveInSvg = (props) => {

  const { width, height, color } = props;

  const theme = useTheme();

  return (
    <svg width={width ?? "15"} height={height ?? "14"} viewBox="0 0 15 14" fill={color ?? theme?.colour?.primary ?? "#6457E8"} xmlns="http://www.w3.org/2000/svg">
      <path fillRule="evenodd" clipRule="evenodd" d="M5.59706 6.48665C5.3054 6.48665 5.07478 6.71331 5.07478 6.99998C5.07478 7.27998 5.3054 7.51331 5.59706 7.51331H9.66683V10.7C9.66683 12.3333 8.31702 13.6666 6.64842 13.6666H3.34512C1.6833 13.6666 0.333496 12.34 0.333496 10.7066V3.29998C0.333496 1.65998 1.69009 0.333313 3.35191 0.333313H6.66198C8.31702 0.333313 9.66683 1.65998 9.66683 3.29331V6.48665H5.59706ZM12.087 4.69344L14.0337 6.63344C14.1337 6.73344 14.187 6.8601 14.187 7.0001C14.187 7.13344 14.1337 7.26677 14.0337 7.3601L12.087 9.3001C11.987 9.4001 11.8537 9.45343 11.727 9.45343C11.5937 9.45343 11.4603 9.4001 11.3603 9.3001C11.1603 9.1001 11.1603 8.77343 11.3603 8.57343L12.427 7.51344H9.66699V6.48677H12.427L11.3603 5.42677C11.1603 5.22677 11.1603 4.9001 11.3603 4.7001C11.5603 4.49344 11.887 4.49344 12.087 4.69344Z" />
    </svg>
  );
}